import { makeStyles } from '@material-ui/core';
import { Mixin } from '@monorepo/common';

// '@media(max-width: 768px)': {},
export const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  btn_wrapper: {
    padding: '5px 0 25px',
    ...Mixin.mixin.flex('center', 'center')
  },
  btn_wrapper_copy: {
    padding: '0px 0 25px',
    ...Mixin.mixin.flex('center', 'center')
  },
  btn_wrapper_comment: {
    ...Mixin.mixin.flex('center', 'center')
  },
  head_item_wrapper: {
    width: '50%',
    '@media(max-width: 665px)': {
      width: '100%'
    }
  },
  inner_wrapper_content: {
    padding: '0px 25px 0px 25px',
  },
  comment_wrapper: {
    paddingTop: 7,
    ...Mixin.mixin.flex('center', 'center')
  },
  btn: {
    textDecoration: 'none'
  },
  top_panel: {
    marginBottom: '1rem',
    '& a': {
      textDecoration: 'none'
    }
  },
  step3_address_wrap: {
    ...Mixin.mixin.flex('flex-start', 'flex-start'),
    gridGap: '2rem',
    marginBottom: '2rem',
    '& > div': {
      flex: 1,
      marginBottom: 0,
      '@media(max-width: 768px)': {
        marginBottom: '2rem'
      }
    },
    '@media(max-width: 768px)': {
      display: 'block'
    }
  },
  location_wrapper: {
    '& ~ $location_wrapper': {
      marginTop: 45
    }
  },
  last_field: {
    marginBottom: 10
  },
  couple_line: {
    ...Mixin.mixin.flex('flex-start', 'center'),
    gridGap: '1rem',
    '@media(max-width: 768px)': {
      display: 'block'
    },
    '& > div': {
      flex: 1
    }
  },
  wrapper_for_additional_email: {
    ...Mixin.mixin.flex('center', 'space-between'),
    '& + $wrapper_for_additional_email': {
      marginTop: '1rem'
    }
  },
  additional_email: {
    marginBottom: 0,
    flex: 1
  },
  additional_email_remove: {
    cursor: 'pointer',
    marginLeft: '1rem',
    '&:hover': {
      fill: 'red'
    }
  },
  field_comment: {
    margin: 0,
    fontSize: '12px !important',
    color: '#65748B'
  },
  comment: {
    margin: 0,
    fontSize: '14px !important',
    minHeight: '40px',
    color: '#65748B',
    '@media(max-width: 665px)': {
      minHeight: 'auto'
    }
  },

  comment_bottom: {
    marginBottom: '0 !important',
    fontSize: '14px !important',
    minHeight: '40px',
    color: '#65748B',
    '@media(max-width: 865px)': {
      minHeight: 'auto',
      marginBottom: '12px !important'
    }
  },

  deactivate_btn: {
    border: '1px solid black',
    backgroundColor: 'white',
    borderColor: '#f44336',
    marginTop: 0,
    color: 'red',
    '&:hover': {
      background: '#f44336',
      color: 'white'
    }
  }
}));
